// React&NextJS
import { useState } from 'react'
import { GetServerSideProps } from 'next'
// 3rd party libraries
import algoliasearch from 'algoliasearch'
import { Hits } from 'react-instantsearch-dom'
// Services&Helper functions
import helperFunctions from '../utils/helperFunctions'
// Types
import { Memory, ScrapedFunerals } from '../types/types'
// Styles
import s from '../styles/pages/RecentlyDeceased.module.scss'
// Components
import Card from '../components/cards/card/Card'
import { Container } from '../components/core/container/Container'
import { Grid } from '../components/core/grid/Grid'
import Meta from '../components/meta/Meta'
import { Section } from '../components/core/section/Section'
import { Text } from '../components/core/text/Text'
import NewShareModal from '../components/components/modals/NewShareModal'
import { Button } from '../components/core/button/Button'

// algolia config
const client = algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
    process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY
)
const index = client.initIndex('memories')

export const getServerSideProps: GetServerSideProps = async () => {
    // Get all the memories hits from firebase with algolia

    // var today = new Date()
    // var lastweek = new Date(
    //     today.getUTCFullYear(),
    //     today.getUTCMonth(),
    //     today.getUTCDate() - 28,
    //     0,
    //     0,
    //     0
    // )

    const memHits = await index
        .search('', {
            // filters: `data.death >= ${lastweek.getTime()}`,
            hitsPerPage: 100,
        })
        .then((hits) => {
            return hits
        })
        .catch((err) => console.error(err))

    return {
        props: {
            memHits,
        },
    }
}

export default function RecentlyDeceaced({ memHits }: { memHits: Hits }) {
    const memories = memHits.hits.map((h: any) => {
        return { ...h.data, objectID: h.objectID }
    })

    const [isOpen, setIsOpen] = useState(false)
    const [funeral, setFuneral] = useState<ScrapedFunerals>(null)

    const closeModal = () => {
        setFuneral(null)
        setIsOpen(false)
    }

    return (
        <>
            <NewShareModal
                isOpen={isOpen}
                closeModal={() => closeModal()}
                title={
                    'Viltu stofna eða benda aðstandanda á að stofna minningarsíðu?'
                }
                info={`Við sjáum að ekki er til minningarsíða um ${funeral?.fullName} á Minningar.is. Þú getur stofnað minningarsíðu í nokkrum einföldum skrefum, eða bent aðstandanda á það.`}
                data={funeral}
                imgURL="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/shareCards%2Fdefault-card.png?alt=media&token=ed39ad70-200f-48fe-a8f1-277b37bb86f5"
            >
                <Button
                    type="button"
                    variant="ghost"
                    className={s.btnPadd}
                    to={`/memories/form?deceasedId=${funeral?.objectID}`}
                >
                    Stofna minningarsíðu
                </Button>
                <Text variant="date">Senda hugmyndina á aðstandanda</Text>
            </NewShareModal>
            <Section noDynamicPadding>
                <Meta
                    title="Minningar - Nýleg andlát"
                    seoTitle="Minningar - Nýleg andlát"
                    url="https://minningar.is/recently-deceased/"
                    description="Andlátstilkynningar síðustu fjögurra vikna, í þeirri röð sem þær berast."
                    type="website"
                    image="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/meta%2FMinningar_7V4A5419_01-min-nyleg-andlat.jpg?alt=media&token=54f19520-553c-40bc-9650-93fdeb36e656"
                />
                <Container className={s.header}>
                    <Text
                        variant="h1"
                        align="center"
                        className={s.header__item}
                    >
                        Nýleg andlát
                    </Text>
                    <Text
                        variant="p-18"
                        align="center"
                        className={s.header__item}
                    >
                        Andlátstilkynningar síðustu fjögurra vikna, í þeirri röð
                        sem þær berast.
                    </Text>
                </Container>
                <Grid>
                    {memories.map((m: Memory, i: number) => {
                        // algolia only return seconds unlike firebase!
                        const birthDate: string = helperFunctions.getDate(
                            m.birth
                        )
                        const deathDate: string = helperFunctions.getDate(
                            m.death
                        )

                        if (!m.scraped) {
                            return (
                                <div key={i}>
                                    <Card
                                        size="4"
                                        header={m.fullName}
                                        headerSize="h4"
                                        lifeTime={`${birthDate} - ${deathDate}`}
                                        imageSrc={m.profileImg}
                                        to={{
                                            link: `/memories/${m.objectID}`,
                                            label: 'Lesa meira',
                                        }}
                                    />
                                </div>
                            )
                        } else {
                            return (
                                <div key={i}>
                                    <Card
                                        size="4"
                                        header={m.fullName}
                                        headerSize="h4"
                                        lifeTime={`${birthDate} - ${deathDate}`}
                                        imageSrc={m.profileImg}
                                        // scrapedInfo={m.scrapeInfo}
                                        type="recent"
                                        to={{
                                            id: `${m.fullName}-recent`,
                                            link: '',
                                            onClick: () => {
                                                setFuneral(m as any)
                                                setIsOpen(true)
                                            },
                                            label: 'Stofna minningarsíðu',
                                        }}
                                    />
                                </div>
                            )
                        }
                    })}
                </Grid>
            </Section>
        </>
    )
}
